<div id="heading">
    <h1>Staff Committees</h1>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item" routerLink="/"><a href="#">Home</a></li>
            <li class="breadcrumb-item"><a href="#">About Us</a></li>
            <li class="breadcrumb-item active" aria-current="page">Staff Committees</li>
        </ol>
    </nav>
</div>

<div id="committee">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h2 class="title">Staff Committees 2025-26</h2>
                <hr>
            </div>
        </div>

        <div class="row">

            <!-- NCC Officer -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">NCC Officer</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Mr. Joshpreet Singh (Boys Wing)</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Ms. Ravita Saini (Girls Wing)</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- NSS Officer -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">NSS Officer</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Hemant Mishra</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Gian Bhushan</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Payal Lamba (Boys &amp; Girls)</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Time Table Incharge -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Time Table Incharge</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Neelam Behal (Science)</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Ashok Khurana (Commerce)</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Payal Lamba (Arts)</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Sanjay Vij (Sports)</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Women Cell -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Women Cell</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Jaswinder Kaur (Commerce)</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Ms. Gurvinder Kaur (Math) Incharge</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Neena Puri (Microbiology)</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Payal Lamba (Political Science)</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Chief Hostel Warden -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Chief Hostel Warden</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Ms. Gurvinder Kaur</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- SC/ST Committee -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">SC/ST Committee</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Catherine Masih</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Neena Puri</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Gian Bhushan</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Vinay Kumar</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Payal Lamba</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- College Magazine -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">College Magazine</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Catherine Masih</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Cultural Affairs -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Cultural Affairs</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Tilak Raj</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Discipline -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Discipline</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Sanjay Vij</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Purchase Committee -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Purchase Committee</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Sahib Singh</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Vinay Kumar</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Joshpreet Singh</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Mr. Shiv Kumar</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Mr. Trilok Singh</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- University Works -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">University Works</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Anurag</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Seminar / Conference / Research Cell -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Seminar / Conference / Research Cell</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Ashok Khurana</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Catherine Masih</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Varsha Nigam</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Nidhi</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Mr. Jaspreet Singh</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Sikh Museum -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Sikh Museum</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Amarjeet Singh</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Incharge Sports -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Incharge Sports</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Sanjay Vij</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Convener Prospectus Committee -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Convener Prospectus Committee</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Catherine Masih</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Spot Evaluation -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Spot Evaluation</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Amarjit Singh</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- IQAC -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">IQAC</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Catherine Masih</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Bursar -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Bursar</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. R.S. Vohra</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Career Advising & Placement Cell -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Career Advising &amp; Placement Cell</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. R.S. Vohra</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Legal Literacy Cell -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Legal Literacy Cell</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Baljeet Singh</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Public Relation Officer -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Public Relation Officer</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Neena Puri</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Grievance Redressal Committee -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Grievance Redressal Committee</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Baljeet Singh</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Sanjay Vij</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Tilak Raj</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Amarjit Singh</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- DGHE Works -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">DGHE</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Neena Puri</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Guru Har Rai Ji Eco Club -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Guru Har Rai Ji Eco Club</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Amarjit Singh</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Gian Bhushan</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Neelam Behal</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Varsha Nigam</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Mr. Jaspreet Singh</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Ms. Poonam Bhasin</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Mr. Gurcharan Singh</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Canteen Committee -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Canteen Committee</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Iqbal Singh</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Hemant Mishra</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Seema Rani</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Amandeep Kaur</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Kawalpreet Singh</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Ray of Hope -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Ray of Hope</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Varsha Nigam</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Ms. Bhawna Sharma</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Nidhi Mahendru</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Coordinate the activities of Critique -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Critique Society</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Vinay Chandel</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Ramandeep Mahal</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Mr. Amritpal Singh</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Coordinate the Activities on Social Media -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Social Media</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Mr. Jaspreet Singh</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Mr. Etender Singh</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Ms. Nishi</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Ramandeep Mahal</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Ms. Minni Sharma</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Impact Committee -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Impact Committee</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Payal Lamba</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Joshpreet Singh</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Mr. Etender Singh</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- UGC -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">UGC</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Kiranpal Singh</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Rotary Club -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Rotary Club</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Hemant Mishra</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Ms. Manisha</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Internship Cell -->
            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Internship Cell</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li>
                                <i class="bi bi-check2-all"></i>
                                <span>Dr. Jaswinder Kaur (Internship Coordinator) <span class="fw-bold">Teacher
                                        Incharge</span></span>
                            </li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Sahib Singh (Arts)</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Payal Lamba (Arts)</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Ashok Khurana (Commerce)</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Pritam Singh Virk (Physical Science)</span>
                            </li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Gian Bhushan (Life Science)</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Kiran Pal Singh Virk (BCA)</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Sanjay Vij (Sports)</span></li>
                        </ul>
                    </div>
                </div>
            </div>


            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Swayam Cell</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Ms. Pooja Rana (Co-ordinator)</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Varsha Nigam</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Amandeep Kaur</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Mr. Jaspreet Singh</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Mr. Itender Singh</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Dr. Nidhi Mahendru</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Ms. Dolly Arora</span></li>
                            <li><i class="bi bi-check2-all"></i><span>Ms. Manisha</span></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card shadow-lg committee-card">
                    <div class="card-header committee-header text-center">Adventure Club</div>
                    <div class="card-body committee-body">
                        <ul class="committee-list">
                            <li><i class="bi bi-check2-all"></i><span>Dr. Kiranpal Singh</span></li>

                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>